






























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import Vivus from 'vivus';
import { fromEvent } from 'rxjs';
import { Prop } from 'vue-property-decorator';
import ButtonDefault from '@/components/button/default.vue';
import TextBasic from '@/components/text/basic.vue';
import BoxNumber from '@/components/box/number.vue';
import BoxEntry from '@/components/box/entry.vue';
import BoxModal from '@/components/box/modal.vue';
import Slick from 'vue-slick';

@Component({
  components: {
    ButtonDefault,
    TextBasic,
    BoxNumber,
    BoxEntry,
    BoxModal,
    Slick,
  },
})
export default class Index extends Vue {

  /*
  * SlickOption
  */
  public SlickOption: any = {
    infinite: false,
    dots: false,
    arrows: false,
    autoplay: false,
    variableWidth: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    // mobileFirst: true,
    responsive: [
      {
        // 1024以下
        breakpoint: 1024,
        // settings: 'unslick',
        settings: {
          infinite: false,
          autoplay: true,
          variableWidth: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
  };

  /**
   * ページタイトル
   */
  @Prop()
  public title!: string;

  /**
   * イントロ開始真偽値
   */
  public isAnimationActive: boolean = false;

  /**
   * View more スクロール要素
   */
  private viewMore!: HTMLElement;

  /**
   * アニメーション要素
   */
  private animation!: HTMLElement;

  /**
   * createdフック
   */
  public created(): void {
    document.title = this.title;
    (window as any).$ = require('jquery');
  }

  /**
   * mountedフック
   */
  public mounted(): void {
    fromEvent(window, 'load').subscribe((event: any): void => {
      this.isAnimationActive = true;
    });

    setTimeout((): void => {
      this.isAnimationActive = true;
    }, 3000);

    this.viewMore = this.$refs.viewMore as HTMLElement;
    this.animation = this.$refs.animation as HTMLElement;

    // fixed解除
    setTimeout((): void => {
      const target: any = document.getElementById('pop-image');

      if (target) {
        document.body.removeChild(target);
      }

      document.body.style.overflow = 'auto';
      this.$store.commit('setFixed', false);
    }, 200);

    const vivus: any = new Vivus('team', {
      type: 'scenario',
      duration: 3000,
      forceRender: false,
      pathTimingFunction: Vivus.EASE_OUT,
    }, (): void => {
      setTimeout((): void => {
        this.viewMore.classList.add('is-visible');
      }, 1000);
    });

    fromEvent(window, 'scroll').subscribe((event: any): void => {
      this.setShowClass();
      vivus.finish();
      this.viewMore.classList.add('is-hide');
    });

    fromEvent(document, 'click').subscribe((event: any): void => {
      this.setShowClass();
      vivus.finish();
      this.viewMore.classList.add('is-visible');
    });
  }

  /**
   * Slickオートプレイ
   */
  public setPlay(): void {
    (this.$refs.slick as any).reSlick();
  }

  /**
   * ページ移動
   */
  public popPage(ref: string, path: string, selector: string): void {
    if ((this as any).mq('md-')) {
      this.$router.push({
        name: path,
      });
      return;
    }

    const target: any = this.$refs[ref] as any;
    const copy: any = target.cloneNode(true);
    const rect: any = target.getBoundingClientRect();
    copy.classList.add(selector);
    copy.setAttribute('id', 'pop-image');
    copy.width = target.width;
    copy.height = target.height;
    copy.style.maxHeight = '800px';
    copy.style.top = window.scrollY + rect.top + 'px';
    copy.style.left = window.scrollX + rect.left + 'px';
    document.body.appendChild(copy);
    document.body.style.overflow = 'hidden';

    setTimeout((): void => {
      target.style.opacity = '0';
      const height: number = window.innerWidth * this.$store.getters.aspect;
      $(copy).animate({
        width: window.innerWidth + 'px',
        height: (height < 620 ? 620 : height) + 'px',
        top: window.scrollY + 'px',
        left: '0',
      }, 200, (): void => {
        this.$router.push({
          name: path,
        }, (): void => {
          copy.classList.add('is-fixed');
          this.$store.commit('setFixed', true);
        });
      });

      $(this.animation).animate({
        opacity: '0',
      }, 100);
    }, 100);
  }

  /**
   * VOICE詳細ページに移動
   */
  public popVoice(event: any, path: string, index: number): void {
    if ((this as any).mq('md-')) {
      this.$router.push({
        name: path,
      });
      return;
    }

    const position = [
      {
        top: 0,
        right: -74,
      },
      {
        top: 10,
        right: -89,
      },
      {
        top: 10,
        right: -89,
      },
    ];

    const image = (event.currentTarget as any).querySelector('.fn-image');
    const copy: any = image.cloneNode(true);
    const rect: any = image.getBoundingClientRect();
    copy.setAttribute('id', 'pop-image');
    copy.classList.add('pop-image');
    copy.style.top = window.scrollY + rect.top + 30 + 'px';
    copy.style.left = window.scrollX + rect.left + 150 + 'px';
    image.style.opacity = '0';
    document.body.appendChild(copy);
    document.body.style.overflow = 'hidden';
    document.getElementById('index')!.classList.add('is-hide');
    copy.classList.add('is-animation');

    setTimeout((): void => {
      const width: number = document.getElementById('intro-inner')!.clientWidth;
      $(copy).animate({
        top: 150 + position[index].top + 'px',
        left: ((window.innerWidth - width) / 2) + (width - 135) - position[index].right + 'px',
      }, 200, (): void => {
        copy.classList.add('is-fixed');
        this.$router.push({
          name: path,
        }, (): void => {
          this.$store.commit('setFixed', true);
        });
      });
      $('html, body').animate({
        scrollTop: 0,
      }, 200);
    }, 100);
  }

  /**
   * scrollList
   */
  public scrollList(event: any): void {
    const button = document.querySelectorAll('.js-areaSwitch');
    const areaItem = document.querySelectorAll<HTMLElement>('.js-areaItem');
    const areaBg = document.querySelector('.js-areaBg');
    const sectionList = $('.section-recruit__list');
    for (const item of areaItem) {
      if (event.currentTarget.textContent === item.getAttribute('id')) {
        const itemTop = item.offsetTop - 20;
        sectionList.animate({
          scrollTop: itemTop,
        }, 500);
        break;
      }
    }
    button.forEach((el) => { el.classList.remove('is-current'); });
    event.currentTarget.classList.add('is-current');
  }

  /**
   * areaOpen
   */
  public areaOpen(event: any): void {
    const button = document.querySelectorAll('.js-areaSwitch');
    button.forEach((el) => { el.classList.remove('is-current'); });
    event.currentTarget.classList.remove('is-current');
  }

  /**
   * selectArea
   */
  public selectKanto(): void {
    const button = document.querySelectorAll('.js-areaSwitch');
    const inner = document.querySelector('.js-inner');
    inner!.classList.remove('is-kyushu');
    inner!.classList.add('is-kanto');
    button.forEach((el) => { el.classList.remove('is-current'); });
    document.getElementById('kyushuList')!.classList.remove('is-active');
    document.getElementById('kantoList')!.classList.add('is-active');
    document.querySelector('.js-selectKyushu')!.classList.remove('is-current');
    document.querySelector('.js-selectKanto')!.classList.add('is-current');
  }

  /**
   * selectArea
   */
  public selectKyushu(): void {
    const inner = document.querySelector('.js-inner');
    inner!.classList.remove('is-kanto');
    inner!.classList.add('is-kyushu');
    document.getElementById('kantoList')!.classList.remove('is-active');
    document.getElementById('kyushuList')!.classList.add('is-active');
    document.querySelector('.js-selectKanto')!.classList.remove('is-current');
    document.querySelector('.js-selectKyushu')!.classList.add('is-current');
  }

  /**
   * イントロ表示クラス追加
   */
  private setShowClass(): void {
    this.animation.classList.add('is-show');
    setTimeout((): void => {
      this.animation.classList.remove('animation');
    }, 500);
  }

}
